/*
 * @Author: zhan lin sen 
 * @Date: 2020-03-27 15:36:25
 * @LastEditTime: 2020-03-27 15:50:35
 * @LastEditors: Please set LastEditors
 * @Description: 注册全局alert组件
 * @FilePath: \trunk\src\components\alert.js
 */

import Alert from './Alert.vue';
import Vue from 'vue';

const AlertConstructor = Vue.extend(Alert); //使用基础 Vue 构造器，创建一个“子类”
let instance;
const initInstance = () => {
    instance = new AlertConstructor(); //创建alert组件
    document.body.appendChild(instance.$mount().$el); //挂载到页面上
};

Vue.prototype.$alert = (content, time) => {
    if (!instance) {
        initInstance();
    }
    let duration = time || 3000;
    instance.value = true;
    instance.content = content;
    setTimeout(() => {
        instance.value = false;
    }, duration);
};

Alert.install = function(Vue) { //注册alert组件
    Vue.component(Alert.name, Alert);
};
export default Alert;
